import styled from 'styled-components';
import { DescriptionSubtitle as DescriptionSubtitleInner } from '../../../for-governments/components/intro/styled';
import { Button } from 'kl-b2c-ui-kit';
import { mediaSm } from 'theme/theme-helper-selectors';

export const DescriptionContainer = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    @media (${mediaSm}) {
        flex-direction: column;
        padding-bottom: 20px;
    }
`;

export const ButtonsContainer = styled.div`
    display: flex;
    flex-direction: column;
    gap: 16px;
`;

export const DescriptionSubtitle = styled(DescriptionSubtitleInner)`
    max-width: 700px;

    @media (${mediaSm}) {
        max-width: 100%;
    }
`;

export const ContactButton = styled(Button)``;
